import { NgTemplateOutlet } from '@angular/common';
import { Component, input, InputSignal, ChangeDetectionStrategy } from '@angular/core';
import { ProductPriceFormatterComponent } from '../product-price-formatter';

@Component({
  selector: 'ui-product-prices-discount',
  templateUrl: './product-prices-discount.component.html',
  styleUrls: ['./product-prices-discount.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [NgTemplateOutlet, ProductPriceFormatterComponent],
})
export class ProductPricesDiscountComponent {
  public price: InputSignal<number> = input.required();
  public strikethroughPrice: InputSignal<number | undefined> = input();
  public showThousandthsPlace: InputSignal<boolean> = input(false);
  public small: InputSignal<boolean> = input(false);
}
